import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	avatarPickerModalPrimaryButton: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.avatar-picker-modal.avatar-picker-modal-primary-button',
		defaultMessage: 'Select',
		description: 'Primary CTA button in modal to select an icon for a priority',
	},
	avatarPickerGenericError: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.avatar-picker-modal.avatar-picker-generic-error',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'generic error shown when there is an error fetching avatars',
	},
});
